import 'css-chunksrc/client/pages/utilityPage/strategicAxesPage/styles.scss';export default {
  "strategicAxesPage": "_strategicAxesPage_1n84t_1",
  "header": "_header_1n84t_8",
  "title": "_title_1n84t_19",
  "profileNavigation": "_profileNavigation_1n84t_26",
  "menu": "_menu_1n84t_36",
  "button": "_button_1n84t_43",
  "icon": "_icon_1n84t_63",
  "iconBox": "_iconBox_1n84t_71",
  "container": "_container_1n84t_80"
};